module.exports = "/_next/static/images/354fa6ad65234d656f73280f94e45b27-value_proposal_xs.png.webp";